<script>
import options from './ProductList.options'
export default options
</script>

<template>
  <!-- hide entire component if hideNoResults is set and there are no results  -->
  <template v-if="hideNoResults && !resultCount "></template>

  <template v-else>
    <section class="kb-product-list">

      <template v-if="results.length && !displayProperties.hideTotalCount">

        <div class="kb-product-list__meta-top-container" aria-live="polite" :class="{'kb-product-list__meta-top-container--hide': type === 'productsSearch' || type === 'materialsSearch'}">
          <div v-if="!displayProperties.hideTotalCount" class="kb-product-list__results-number">
            {{ totalCountLabel }}
          </div>
          <div class="kb-product-list__results-list-header">{{ getLabel('listHeader') }}</div>
        </div>

        <div class="kb-product-list__meta-top-container kb-product-list__meta-top-container--search" :class="{'kb-product-list__meta-top-container--hide': type === 'products' || type === 'materials'}">
          <h3>
            {{ getLabel('resultTypeTitle') }}
            <span v-if="!displayProperties.hideTotalCount" class="kb-product-list__results-number">
              {{ totalCountLabel }}
            </span>
          </h3>
        </div>

      </template>

    
      <template v-if="!resultCount && !showSpinner && !hideNoResults">
        <div class="kb-product-list__no-results">
          <h2>{{ getLabel('noResultTitle') }}</h2>
          <p class="kb-product-list__no-results-summary">{{ getLabel('noResultDesc') }}</p>
          <a :href="getLabel('noResultButtonHref')" class="kb-button kb-button--full-color-spot">{{
            getLabel('noResultButtonText') }}</a>
        </div>
      </template>

      <template v-else>
        <ul class="kb-product-list__results kb-product-list__results--grid" :class="displayModifications">
          <template v-for="(result, index) in results" :key="index">
            <li>
              <template v-if="result.isSpotCard">
                <SpotCardGrid :spotCardData="result" />
              </template>
              <template v-else>
                <component :is="displayProperties.card" :data="result" :displayProperties="displayProperties" />
              </template>
            </li>
          </template>
        </ul>
      </template>


      <div class="kb-product-list__more-results">
        <span v-if="resultCount" class="kb-product-list__more-results__text">Viser {{ resultCount }} ud af {{ totalCount }}
          {{ getLabel('resultTypeTitle') }} </span>
        <template v-if="canShowMore">
          <button @click="getMoreResults" class="kb-button kb-button--full-color">
            {{ getLabel('showMoreButtonText') }}
          </button>
        </template>
      </div>

      <div v-if="showSpinner" class="kb-spinner-overlay">
        <div class="kb-spinner-overlay__spinner">
        </div>
      </div>

    </section>
  </template>

</template>
